// App.js
import React from "react";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <div className='h-[calc(100vh_-_0rem)]'>
      <AppRoutes />
    </div>
  );
};

export default App;
